import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./OnboardingModals.css";

const TWO_DAYS = 2 * 24 * 60 * 60 * 1000;

const EXCHANGES = [
  {
    name: "WEEX",
    tag: "Option 1",
    glyph: "W",
    color: "linear-gradient(135deg,#1f2937,#111827)",
    code: "z5je",
    steps: ["Deposit 100 USDT", "Copy your WEEX UID", "Verify via the Telegram bot"],
    register: "https://support.weex.com/en/register?vipCode=z5je",
    verify: "https://t.me/WaqarZaka_WEEX_Bot",
  },
  {
    name: "MEXC",
    tag: "Option 2",
    glyph: "M",
    color: "linear-gradient(135deg,#1d4ed8,#3b82f6)",
    code: "1YtSR",
    steps: ["Deposit 100 USDT into Futures Wallet", "Copy your UID", "Verify via the Telegram bot"],
    register: "https://www.mexc.com/register?inviteCode=mexc-1YtSR",
    verify: "https://t.me/WaqarZaka_Mexc_Bot",
  },
  {
    name: "Blofin",
    tag: "Option 3",
    glyph: "B",
    color: "linear-gradient(135deg,#7c3aed,#4c1d95)",
    code: "teamwaqarzaka",
    steps: ["Deposit 100 USDT into Futures Wallet", "Use the invite link", "Verify via the Telegram bot"],
    register: "https://partner.blofin.com/d/TeamWaqarZaka",
    verify: "https://t.me/WaqarZaka_Blofin_Bot",
  },
];

export const OnboardingCongratsModal = ({ SubsData, subsLoaded }) => {
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!subsLoaded) return;
    if (location.pathname === "/" || location.pathname.includes("/admin")) return;
    if (!SubsData?.isSubscription) return;
    const isNew =
      SubsData?.createdAt &&
      Date.now() - new Date(SubsData.createdAt).getTime() < TWO_DAYS;
    setShow(!!isNew);
  }, [SubsData, subsLoaded]);

  if (!show) return null;

  return (
    <div
      className="om-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) setShow(false);
      }}
    >
      <div className="om-modal om-congrats">
        <div className="om-head om-head-prem">
          <div className="om-blob ob2" />
          <button className="om-close" onClick={() => setShow(false)}>
            &#10005;
          </button>
          <div className="om-head-inner">
            <div className="om-pill om-pill-gold">⭐ Premium Member</div>
            <h2 className="om-h2 om-h2-sm">
              Congratulations! You're now part of{" "}
              <span className="om-accent">Team Waqar Zaka</span> 🚀
            </h2>
            <p className="om-sub">
              Our mission is to make crypto &amp; trading easy to understand
              through simple, beginner-friendly education.
            </p>
          </div>
        </div>

        <div className="om-body-scroll">
          {/* Intro video */}
          <a
            href="https://youtu.be/b_y9w_XZlVg?si=GbGNi19CTKX0sNoA"
            target="_blank"
            rel="noopener noreferrer"
            className="om-video-row"
          >
            <span className="om-yt-ic"><i className="fa-brands fa-youtube" /></span>
            <span>
              <span className="om-vt">Watch the intro video first</span>
              <span className="om-vs">Required before using the platform</span>
            </span>
          </a>

          {/* Telegram Setup */}
          <div className="om-sec-head">
            <span className="om-sec-ic om-tg-ic"><i className="fa-brands fa-telegram" /></span>
            <h3 className="om-sec-title">
              Telegram Setup <small>(No VPN Required)</small>
            </h3>
          </div>
          <div className="om-steps-box">
            <p className="om-steps-note">
              If Telegram is blocked in your country (e.g. Pakistan or Iran):
            </p>
            <div className="om-steps">
              {[
                "Uninstall Telegram (if already installed).",
                "Open mtpro.xyz/mtproto",
                "Select any MTProto proxy server.",
                "Reinstall Telegram.",
                "Telegram connects automatically through the proxy.",
              ].map((s, i) => (
                <div key={i} className="om-step">
                  <span className="om-step-n">{i + 1}</span>
                  <span>{s}</span>
                </div>
              ))}
            </div>
            <div className="om-perks">
              {["✓ No VPN required", "✓ Official MTProto Proxy", "✓ Android & iPhone"].map(
                (p, i) => (
                  <span key={i} className="om-perk">
                    {p}
                  </span>
                )
              )}
            </div>
          </div>

          {/* Exchange */}
          <div className="om-sec-head" style={{ marginTop: 20 }}>
            <span className="om-sec-ic om-vip-ic"><i className="fa-solid fa-chart-line" /></span>
            <h3 className="om-sec-title">Join the VIP Future Trading Group</h3>
          </div>
          <p className="om-exchange-note">
            Choose one exchange below. Deposit <strong>100 USDT</strong>, copy
            your UID, then verify via the Telegram bot.
          </p>
          <div className="om-opt-list">
            {EXCHANGES.map((ex, i) => (
              <div key={i} className="om-opt">
                <div className="om-opt-top">
                  <div className="om-opt-left">
                    <span
                      className="om-opt-badge"
                      style={{ background: ex.color }}
                    >
                      {ex.glyph}
                    </span>
                    <span className="om-opt-name">{ex.name}</span>
                  </div>
                  <span className="om-opt-tag">{ex.tag}</span>
                </div>
                <div className="om-opt-code-row">
                  <span className="om-opt-code-label">Referral Code</span>
                  <span className="om-opt-code">{ex.code}</span>
                </div>
                <div className="om-opt-steps">
                  {ex.steps.map((s, j) => (
                    <div key={j} className="om-opt-step">
                      <span>•</span>
                      <span>{s}</span>
                    </div>
                  ))}
                </div>
                <div className="om-opt-btns">
                  <a
                    className="om-opt-btn-a"
                    href={ex.register}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Register ↗
                  </a>
                  <a
                    className="om-opt-btn-b"
                    href={ex.verify}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Verify on Telegram
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="om-warn">
            <span>⚠️</span>
            <span>
              Accounts <strong>not</strong> created with the referral code will
              not be accepted.
            </span>
          </div>
        </div>

        <div className="om-foot om-foot-prem">
          <button
            className="om-btn-primary om-btn-full"
            onClick={() => setShow(false)}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};
